import { canActor } from '../domain/authorization'
import type { ActorContext } from '../domain/authorization'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { WorkItem, WorkItemPort } from '../domain/workflow'

const cancelWorkItem = async (
	port: WorkItemPort,
	item: WorkItem,
	ctx: ActorContext,
	reason: string,
	notify: NotifyPort,
	phaseTeamId: string | null = null,
): Promise<WorkItem | null> => {
	if (!canActor('cancel', item, ctx, phaseTeamId)) {
		notify.error('workItem.denyCancel')
		return null
	}
	try {
		const updated = await port.cancelWorkItem(item.id, ctx.actorId, ctx.actorName, reason)
		notify.success('workItem.cancelled')
		return updated
	} catch {
		notify.error('workItem.cancelFailed')
		return null
	}
}

export { cancelWorkItem }
